import { isInternalUser } from "lib/entitlements";
import { unqiueElems } from "lib/utils";
import { i18n } from "app/i18n/i18n";
import { features } from "app/features";

export function parseFaqItems(json) {
  try {
    const lang = i18n.getLanguage();
    const data = (json && json.data) || [];
    const faqItems = removePublicFaqContent(data);
    const filteredFaqItems = !isInternalUser()
      ? removeInternalContent(faqItems)
      : faqItems;

    if (features.sortFaqBySortField) filteredFaqItems.sort(sortFaq);
    const categories = filteredFaqItems.map((faqItem) => faqItem["category_" + lang]);
    return [filteredFaqItems, unqiueElems(categories)];
  } catch (err) {
    console.error("Error parsing faq items", err);
    return [[], [], true];
  }
}

const removePublicFaqContent = (faq) => faq.filter((faqItem) => faqItem.role !== "Public");
const removeInternalContent = (faq) => faq.filter((faqItem) => faqItem.role !== "Internal");
const sortFaq = (faqA, faqB) => faqA.sortOrder - faqB.sortOrder;